<div class="container">
  <h2 class="section-title">{{ 'aircraft.registration.title' | translate }}</h2>

  <h2 class="section-sub-title">
    {{ 'aircraft.registration.companySection' | translate }}
  </h2>
  <div class="form-row half-width">
    <mat-form-field appearance="outline">
      <mat-label>{{
        'aircraft.registration.companyLabel' | translate
      }}</mat-label>
      <mat-select [(value)]="selectedCompany" required>
        <mat-option *ngFor="let company of companies" [value]="company">
          {{ company.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="!selectedCompany">
        {{ 'aircraft.registration.companyRequired' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <h2 class="section-sub-title">
    {{ 'aircraft.registration.importSection' | translate }}
  </h2>
  <div class="form-row">
    <mat-card
      *ngIf="!uploadedCSV"
      class="upload-options-card"
      appearance="outlined"
    >
      <mat-card-content>
        <p>{{ 'aircraft.registration.importInstruction' | translate }}</p>
        <br />
        <p>
          {{ 'aircraft.registration.sampleInstruction' | translate }}
          <a class="file" href="assets/fake_uavs_data_for_import.csv" download>
            {{ 'aircraft.registration.sampleLink' | translate }}
            <mat-icon>description</mat-icon>
          </a>
        </p>
      </mat-card-content>
      <mat-card-footer class="upload-options-card-footer">
        <app-file-upload
          #fileUploadComponent
          inputLabel="Import csv"
          [allowedFileTypes]="['application/csv']"
          [selectableFileTypes]="'.csv'"
          (fileUploaded)="onFileSelected($event)"
        ></app-file-upload>
      </mat-card-footer>
    </mat-card>
    <div *ngIf="uploadedCSV" class="file-list-item">
      <mat-icon>description</mat-icon> {{ uploadedCSV.name }} ({{
        (uploadedCSV.size / 1024).toFixed(2)
      }}
      KB)
      <mat-icon (click)="removeAttachment()" class="close">close</mat-icon>
    </div>
  </div>

  <div *ngIf="aircraftFromCSV.length && steps.review">
    <h2 class="section-sub-title">
      {{ 'aircraft.registration.reviewSection' | translate }}
    </h2>
    <qs-table [data]="aircraftFromCSV" [columns]="reviewTableColumn"></qs-table>
  </div>
  <div *ngIf="validatedAircraft.length && steps.approve">
    <h2 class="section-sub-title">
      {{ 'aircraft.registration.validationResultSection' | translate }}
    </h2>
    <qs-table
      [data]="validatedAircraft"
      [columns]="validationTableColumn"
      [rowStyleFn]="getAircraftRowClass"
    ></qs-table>
  </div>

  <div *ngIf="!steps.upload" class="footer-line"></div>

  <div *ngIf="steps.review" class="cancel-save-button-container">
    <app-button
      [disabled]="!selectedCompany"
      (click)="onValidationRequest()"
      [tall]="true"
      title="Validate"
      [matTooltip]="
        !selectedCompany
          ? ('aircraft.registration.companyRequiredTooltip' | translate)
          : ''
      "
      [matTooltipDisabled]="!!selectedCompany"
      class="flex-position-end"
    >
    </app-button>
  </div>
  <div
    *ngIf="validatedAircraft.length && steps.approve"
    class="cancel-save-button-container"
  >
    <app-button
      [disabled]="!hasValidAsignableAircraft"
      (click)="openAssignAircraftModal()"
      [tall]="true"
      title="Assign"
      class="flex-position-end"
      [matTooltip]="
        !hasValidAsignableAircraft
          ? ('aircraft.registration.valid_assignable_aircraft' | translate)
          : ''
      "
      [matTooltipDisabled]="!!hasValidAsignableAircraft"
    >
    </app-button>
  </div>
</div>
